<!--
	Wrapper component: renderless. The script owns state and keyboard handling; the template only
	exposes them through a scoped slot and renders no markup of its own. Twig owns every
	line of markup inside <gallery-lightbox …> and binds to the slot props with v-slot="{ … }",
	v-show, :class, and @click. Inputs arrive as kebab-case attributes on the tag.
-->
<template>
	<slot v-bind="{ index, isOpen, open, close, next, prev }" />
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";

const props = defineProps({
	count: {
		type: Number,
		required: true,
	},
	// The id of the gallery root element in Twig; its videos pause when the slide changes
	galleryId: {
		type: String,
		required: true,
	},
});

// -1 means closed
const index = ref(-1);

const isOpen = computed(() => index.value > -1);

function open(i) {
	index.value = i;
}

function close() {
	index.value = -1;
}

function next() {
	index.value = (index.value + 1) % props.count;
}

function prev() {
	index.value = (index.value - 1 + props.count) % props.count;
}

function onKeydown(e) {
	if (e.key === "Escape") {
		close();
	} else if (isOpen.value && e.key === "ArrowRight") {
		next();
	} else if (isOpen.value && e.key === "ArrowLeft") {
		prev();
	}
}

onMounted(() => window.addEventListener("keydown", onKeydown));
onBeforeUnmount(() => window.removeEventListener("keydown", onKeydown));

watch(index, () => {
	document
		.getElementById(props.galleryId)
		?.querySelectorAll("video[controls]")
		.forEach((video) => video.pause());
});
</script>
